// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__38qoX","unreadBadge":"styles_unreadBadge__16n6M","modalContent":"styles_modalContent__2Jo7C","modal":"styles_modal__2TsgK"};